export function savePosts(state){
  return {
    type: 'SAVE_POSTS',
    payload: state
  }
};